// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"6f842a27","261":"44fc292f"}[chunkId] + ".chunk.css";
};